import { useState } from 'react';

import { SearchIdContext } from '@app/providers/SearchIdProvider/SearchIdContext';
import type { NSearchIdProvider } from '@app/providers/SearchIdProvider/SearchIdProvider.types';

export const SearchIdProvider: NSearchIdProvider.Main = ({ children }) => {
  const [searchId, setSearchId] = useState<NSearchIdProvider.SearchId>(null);

  return (
    <SearchIdContext.Provider
      value={{
        searchId,
        setSearchId,
      }}
    >
      {children}
    </SearchIdContext.Provider>
  );
};
